import { useSearchParamsState } from "utils/general";

import { stepNoToUrlValue, urlValueToStepNo } from "../lib/urlState";
import { ADD_BUILDING_STEP_PARAM } from "../model/constants";

export const useStepNoUrlSync = () => {
  const [stepNo, setStepNo] = useSearchParamsState<number>({
    paramName: ADD_BUILDING_STEP_PARAM,
    parse: urlValueToStepNo,
    serialize: stepNoToUrlValue,
  });

  return { setStepNo, stepNo };
};
